module.exports = {"id":"213580","name":"Lucas Mugni","rating":"72","photo":"./data/images/photos/1/213580.png","club":{"name":"CD Everton","logo":"./data/images/clubs/CDEverton.png"},"positions":["MOC","MG","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LucasMugni0.json
// module id = 2577
// module chunks = 0